
export class EventManager {

    /* INSTANCE */
    public static instance: EventManager;
    private customEvent: CustomEvent | null = null;
    private readonly availableIds: string[];

    /* STATIC */
    public static build(): EventManager {
        if (!this.instance) {
            EventManager.instance = new this();
        }
        return this.instance;
    }

    constructor() {
        this.availableIds = [];
    }

    public addId(id: string) {
        if (!this.availableIds.includes(id)) {
            this.availableIds.push(id);
        }
    }

    public createCustomEvent(kv: string) {
        const elementToProcess = this.availableIds.shift();
        if (elementToProcess) {
            this.customEvent = new CustomEvent(elementToProcess, {
                detail: { kv: kv },
                bubbles: true
            });
        }
    }

    public dispatchCustomEvent() {
        if (this.customEvent) {
            document.dispatchEvent(this.customEvent);
            this.customEvent = null;
        }
    }

}
